export default "__VITE_ASSET__DASq0Lp8__"